import { Action } from 'redux';
import { Report, Metadata } from 'types/api/responses';

export enum ReportActions {
  FETCH_REPORTS = 'session/reports/get',
  FETCH_REPORTS_SUCCESS = 'session/reports/getSucess',
  FETCH_REPORTS_FAILURE = 'session/reports/getFailure',
  UPDATE_REPORT = 'session/reports/update',
  UPDATE_REPORT_SUCCESS = 'session/reports/updateSucess',
  UPDATE_REPORT_FAILURE = 'session/reports/updateFailure',
  COMPARE_REPORTS = 'session/reports/compare',
  COMPARE_REPORTS_SUCCESS = 'session/reports/compareSucess',
  COMPARE_REPORTS_FAILURE = 'session/reports/compareFailure',
}

type ReportsFetch = {
  isLoading: boolean;
  error?: undefined;
} & Action<typeof ReportActions.FETCH_REPORTS>;

type ReportsFetchSuccess = {
  reports: {
    reports: Report[];
    meta: Metadata;
  };
} & Action<typeof ReportActions.FETCH_REPORTS_SUCCESS>;

type ReportsFetchFailure = {
  error: Error;
} & Action<typeof ReportActions.FETCH_REPORTS_FAILURE>;

type ReportUpdate = {
  isLoading: boolean;
  error?: undefined;
} & Action<typeof ReportActions.UPDATE_REPORT>;

type ReportUpdateSuccess = {
  message: string;
} & Action<typeof ReportActions.UPDATE_REPORT_SUCCESS>;

type ReportUpdateFailure = {
  error: Error;
} & Action<typeof ReportActions.UPDATE_REPORT_FAILURE>;

type ReportCompare = {
  isLoading: boolean;
  error?: undefined;
} & Action<typeof ReportActions.COMPARE_REPORTS>;

type ReportCompareSuccess = {
  comparedReports: Report[];
} & Action<typeof ReportActions.COMPARE_REPORTS_SUCCESS>;

type ReportCompareFailure = {
  error: Error;
} & Action<typeof ReportActions.COMPARE_REPORTS_FAILURE>;

export type ReportsAction =
  | ReportsFetch
  | ReportsFetchSuccess
  | ReportsFetchFailure
  | ReportUpdate
  | ReportUpdateSuccess
  | ReportUpdateFailure
  | ReportCompare
  | ReportCompareSuccess
  | ReportCompareFailure;
